import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import Layout from "components/Layout";

import CustomTable from "components/Table";
import LoadingTable from "components/Table/loading";
import NameAndEmail from "components/Table/components/NameAndEmail";
import CustomDate from "components/Table/components/CustomDate";
import DropdownButton from "components/DropdownButton";
import BackwardAndTitle from "components/BackwardAndTitle";
import ReactPaginate from "react-paginate";
import formatAmount from "utils/formatAmount";
import formatCountry from "utils/formatCountry";

import { getCustomers } from "../../services/api";

function Row({ data }) {
  const actions = [
    {
      label: "Ver detalhes",
      path: `/customers/${data.user_id}`,
      action: () => {},
    },
  ];

  return (
    <tr>
      <td>
        <span>{data.user_id}</span>
      </td>
      <td>
        <NameAndEmail name={data.user.public_name} email={data.user.email} />
      </td>
      <td>
        <CustomDate date={data.user.created_at} />
      </td>
      <td>
        <span>{formatAmount(data.total_paid)}</span>
      </td>
      <td>
        <span>{formatCountry(data.user.country)}</span>
      </td>
      <td>
        <span>
          {data.user.city} / {data.user.state}
        </span>
      </td>
      <td>
        <span>{data.user.phone}</span>
      </td>
      <td>
        <DropdownButton childs={actions} />
      </td>
    </tr>
  );
}

function Customers() {
  const block = useSelector((state) => state.general.block);

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    { field: "id", headerName: "ID" },
    { field: "name", headerName: "Nome" },
    { field: "created_at", headerName: "Data" },
    { field: "value", headerName: "Valor" },
    { field: "country", headerName: "País" },
    { field: "state_city", headerName: "Cidade/Estado" },
    { field: "phone", headerName: "Telefone" },
    { field: "actions", headerName: "" },
  ];

  useEffect(() => {
    async function init() {
      setLoading(true);

      try {
        const { data: customers } = await getCustomers({
          page: currentPage,
          block_id: block?.id,
        });

        const _rows = [];

        for (const [index, value] of customers.results.entries()) {
          _rows.push(<Row data={value} key={index} />);
        }

        setRows(_rows);
        setPageCount(Math.ceil(customers.count / 10));
        setLoading(false);
      } catch (error) {
        console.error("Falha ao buscar clientes", error);
        setPageCount(1);
        setLoading(false);
      }
    }

    return init();
  }, [currentPage, block]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          gap: "2rem",
          width: "100%",
        }}
      >
        <BackwardAndTitle
          loading={loading}
          title="Clientes"
          breadcrumb={[
            {
              href: "/",
              label: "Visão Geral",
            },
            {
              label: "Clientes",
            },
          ]}
        />
        <div className="card">
          {loading ? (
            <LoadingTable />
          ) : (
            <CustomTable columns={columns} rows={rows} />
          )}
          <div className="card-footer flex-end">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Próxima"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              pageClassName="page-item"
              nextClassName="page-link"
              pageLinkClassName="page-link"
              previousClassName="page-link"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Customers;
